export const CATCH_POSITIONS_MINZOOM = 13;
export const CATCH_POSITIONS_SIMPLIFIED_MINZOOM = 9;
export const CATCH_POSITIONS_SIMPLIFIED_CIRCLE_RADIUS = 3;
export const CATCH_POSITIONS_ICON_SIZE = 0.8;
export const SELECTED_CATCH_POSITION_ICON_SIZE = 1.1;
export const SELECTED_CATCH_POSITION_HIGHLIGHT_SIZE = 0.8;

export const MonthToNumberLookup = {
  JANUARY: 1,
  FEBRUARY: 2,
  MARCH: 3,
  APRIL: 4,
  MAY: 5,
  JUNE: 6,
  JULY: 7,
  AUGUST: 8,
  SEPTEMBER: 9,
  OCTOBER: 10,
  NOVEMBER: 11,
  DECEMBER: 12,
};
